import Errors from './Errors';

class Form {
    constructor(data) {
        this.originalData = data;
        this.errors = new Errors();
        this.loading = false;

        for (let field in data) {
            this[field] = data[field];
        }
    }

    reset() {
        for (let field in this.originalData) {
            this[field] = '';
        }

        this.errors.clear();
    }

    data() {
        let data = {};

        for( let property in this.originalData ) {
            data[property] = this[property];
        }

        return data;
    }
}

export default Form;